// File copied from `packages/editor/editor-common/src/ui-menu/ToolbarButton/index.tsx`

/** @jsx jsx */
import React, { useCallback } from 'react';
import { css, jsx } from '@emotion/react';

// This type is vendored to avoid issues with
// @atlaskit/editor-common not being a dependency of this package
// See thread at https://atlassian.slack.com/archives/CFG3PSQ9E/p1696813019827179
// for more details.
// import type { MenuItem } from '@atlaskit/editor-common/ui-menu';

import { FabricChannel } from '@atlaskit/analytics-listeners';
import Tooltip from '@atlaskit/tooltip';
import Button from './styles';
const buttonWrapper = css`
  display: flex;
  height: 100%;
`;
const ToolbarButton = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    buttonId,
    testId,
    className = '',
    href,
    iconAfter,
    iconBefore,
    disabled,
    selected,
    spacing,
    target,
    children,
    hideTooltip,
    title,
    titlePosition = 'top',
    item,
    'aria-label': ariaLabel,
    'aria-haspopup': ariaHasPopup,
    'aria-expanded': ariaExpanded,
    'aria-pressed': ariaPressed,
    'aria-keyshortcuts': ariaKeyShortcuts,
    onClick,
    onKeyDown,
    onItemClick
  } = props;
  const handleClick = useCallback((event, analyticsEvent) => {
    if (disabled) {
      return;
    }
    if (buttonId) {
      analyticsEvent.update(payload => ({
        ...payload,
        action: 'clicked',
        // equivalent to ACTION.CLICKED,
        actionSubject: 'toolbarButton',
        // equivalent to ACTION_SUBJECT.TOOLBAR_BUTTON,
        actionSubjectId: buttonId,
        eventType: 'ui' // equivalent to EVENT_TYPE.UI,
      })).fire(FabricChannel.editor);
    }
    if (onClick) {
      onClick(event);
    }
    if (item && onItemClick) {
      onItemClick(item);
    }
  }, [disabled, onClick, onItemClick, item, buttonId]);
  const id = buttonId ? `editor-toolbar__${buttonId}` : undefined;
  const button = jsx(Button, {
    id: id,
    ref: ref,
    appearance: "subtle",
    testId: testId,
    className: className,
    href: href,
    iconAfter: iconAfter,
    iconBefore: iconBefore,
    isDisabled: disabled,
    isSelected: selected,
    onClick: handleClick,
    spacing: spacing || 'default',
    target: target,
    shouldFitContainer: true,
    "aria-expanded": ariaExpanded,
    "aria-haspopup": ariaHasPopup,
    "aria-label": ariaLabel,
    "aria-pressed": ariaPressed,
    "aria-keyshortcuts": ariaKeyShortcuts,
    onKeyDown: onKeyDown
  }, children);
  if (!title) {
    return button;
  }
  const tooltipContent = !hideTooltip ? title : null;
  return jsx(Tooltip, {
    content: tooltipContent,
    hideTooltipOnClick: true,
    position: titlePosition
  }, jsx("div", {
    css: buttonWrapper
  }, button));
});
export default ToolbarButton;